module.exports = __webpack_public_path__ + "static/projekt_indywidualny_b2-6d3278a13e28f51a4f484360c1d94c48.jpg";